



































import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzContainedButton from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

const browser = namespace('browser')

@Component({ components: { OzContainedButton, OzIcon } })
export default class DashboardSettingsBillingCollectionItem extends Vue {
  @browser.Getter isPhone!: boolean
  @Prop() title!: string
  @Prop() subText?: string
  @Prop() buttonText?: string
  @Prop({ default: false }) disabled?: boolean
}
